import { render } from "./ChatContent.vue?vue&type=template&id=4e6347d8&scoped=true"
import script from "./ChatContent.vue?vue&type=script&lang=js"
export * from "./ChatContent.vue?vue&type=script&lang=js"

import "./ChatContent.vue?vue&type=style&index=0&id=4e6347d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e6347d8"]])

export default __exports__